module.exports = __webpack_public_path__ + "static/media/nav-icon-strength-inactive.f2c903e4.svg";